import { put, call, takeLatest } from "redux-saga/effects";
import { flashMessage } from "redux-flash";
import axios from "axios";
import { push } from "react-router-redux";

import {
  CARDADD_REQUEST,
  cardAddSuccess,
  cardAddError,
  UNSUBCRIPTION_REQUEST,
  unsubcriptionSuccess,
  unsubcriptionError,
  getPlanSuccess,
  getPlanError,
} from "./actions";
import { getUserSuccess } from "../admin/actions";
import { Env } from "../../env";

function* cardAddRequest(action) {
  // console.log('in card Add request');
  const { paymentdetails1, accessToken, userId } = action;
  let response, response1;
  try {
    response = yield call(
      axios.post,
      `${Env.BASE_API_URL}/Accounts/addCard`,
      paymentdetails1,
      { headers: { Authorization: accessToken } }
    );
  } catch (err) {
    let error;
    if (err.response) {
      error =
        "Votre paiement n'a pas pu aboutir. Si le problème persiste, veuillez nous contacter à contact@digidocteur.com";
      yield put(cardAddError(error));
      yield put(flashMessage(error, { timeout: 12000 }));
    }
    return;
  }

  try {
    response1 = yield call(axios.get, `${Env.BASE_API_URL}/Accounts/status`, {
      headers: { Authorization: accessToken },
    });
  } catch (err) {
    if (err.response1 && err.response1.status === 401) {
      yield put(logoutRequest());
    } else {
      error =
        "Votre paiement a abouti, mais nous n'avons pas pu récupérer vos informations. En cas de problème, veuillez nous contacter à contact@digidocteur.com";
      // Active event fb
      switch (localStorage.getItem("autoSelectedPlan")) {
        case "basic":
          fbq("track", "Purchase", { value: 39.0, currency: "EUR" });
          console.log("EVENT BASIC");
          break;
        case "premium":
          fbq("track", "Purchase", { value: 69.0, currency: "EUR" });
          console.log("EVENT PREMIUM");
          break;
        case "tv":
          fbq("track", "Purchase", { value: 89.0, currency: "EUR" });
          console.log("EVENT TV");
          break;
        default:
          fbq("track", "Purchase", { value: 39.0, currency: "EUR" });
          console.log("EVENT PURCHASE FB 39,00");
          console.log(
            "Sorry, we are out of " + localStorage.getItem("autoSelectedPlan")
          );
      }
      yield put(flashMessage(error, { timeout: 12000 }));
      yield put(getSubcriptionError(error));
    }

    return;
  }
  yield put(getUserSuccess(action.user, response1.data));
  // console.log(JSON.stringify('dksdjj_____++++++' + response1.data));

  // console.log(JSON.stringify(response.data));
  yield put(cardAddSuccess(response.data));
  yield put(push("/subscriber"));
  // Active event fb
  switch (localStorage.getItem("autoSelectedPlan")) {
    case "basic":
      fbq("track", "Purchase", { value: 39.0, currency: "EUR" });
      console.log("EVENT BASIC");
      break;
    case "premium":
      fbq("track", "Purchase", { value: 69.0, currency: "EUR" });
      console.log("EVENT PREMIUM");
      break;
    case "tv":
      fbq("track", "Purchase", { value: 89.0, currency: "EUR" });
      console.log("EVENT TV");
      break;
    default:
      fbq("track", "Purchase", { value: 39.0, currency: "EUR" });
      console.log("EVENT PURCHASE FB 39,00");
      console.log(
        "Sorry, we are out of " + localStorage.getItem("autoSelectedPlan")
      );
  }
  yield put(
    flashMessage("Paiement validé. Merci pour votre confiance !", {
      timeout: 5000,
    })
  );
}

export function* watchSaveCardRequest() {
  yield takeLatest(CARDADD_REQUEST, cardAddRequest);
}

function* unsubcriptionRequest(action) {
  // console.log('in card Add request');
  const { accessToken, user } = action;
  let response, response1;
  try {
    response = yield call(
      axios.get,
      `${Env.BASE_API_URL}/Accounts/unsubcription`,
      { headers: { Authorization: accessToken } }
    );
  } catch (err) {
    let error;
    if (
      err.response &&
      (err.response.status === 401 || err.response.status === 422)
    ) {
      error = "something is wrong..!";
      yield put(unsubcriptionError(error));
      yield put(flashMessage(error));
    }
    return;
  }

  try {
    response1 = yield call(axios.get, `${Env.BASE_API_URL}/Accounts/status`, {
      headers: { Authorization: accessToken },
    });
  } catch (err) {
    if (err.response1 && err.response1.status === 401) {
      yield put(logoutRequest());
    } else {
      yield put(getSubcriptionError("Quelque chose ne va pas ..!"));
    }

    return;
  }
  yield put(getUserSuccess(action.user, response1.data));

  yield put(unsubcriptionSuccess(response.data));
  yield put(push("/subscriber"));
  yield put(
    flashMessage("Carte Deatils Ajouter avec succès", { timeout: 5000 })
  );
}

export function* watchUnsubcriptionRequest() {
  yield takeLatest(UNSUBCRIPTION_REQUEST, unsubcriptionRequest);
}

function* getSubscriptionRequest(action) {
  let response;

  try {
    response = yield call(axios.get, `${Env.BASE_API_URL}/plans`);
  } catch (err) {
    yield put(getPlanError("Une erreur s'est produite, veuillez réessayer."));
    yield put(flashMessage("Une erreur s'est produite, veuillez réessayer."));
    return;
  }

  yield put(getPlanSuccess(response.data));
}



// WEBPACK FOOTER //
// ./src/pages/subscription/saga.js